import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    rolesAdminControllerCreateRoleV1: build.mutation<
      RolesAdminControllerCreateRoleV1ApiResponse,
      RolesAdminControllerCreateRoleV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/roles`,
        method: 'POST',
        body: queryArg.createRoleBody,
      }),
    }),
    rolesAdminControllerListRolesV1: build.query<
      RolesAdminControllerListRolesV1ApiResponse,
      RolesAdminControllerListRolesV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/roles` }),
    }),
    rolesAdminControllerGetRoleV1: build.query<
      RolesAdminControllerGetRoleV1ApiResponse,
      RolesAdminControllerGetRoleV1ApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/admin/roles/${queryArg.id}` }),
    }),
    rolesAdminControllerUpdateRoleV1: build.mutation<
      RolesAdminControllerUpdateRoleV1ApiResponse,
      RolesAdminControllerUpdateRoleV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/roles/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateRoleBody,
      }),
    }),
    rolesAdminControllerRemoveRoleV1: build.mutation<
      RolesAdminControllerRemoveRoleV1ApiResponse,
      RolesAdminControllerRemoveRoleV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/roles/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type RolesAdminControllerCreateRoleV1ApiResponse =
  /** status 200 Returns created role */ CreateRoleResponse;
export type RolesAdminControllerCreateRoleV1ApiArg = {
  createRoleBody: CreateRoleBody;
};
export type RolesAdminControllerListRolesV1ApiResponse =
  /** status 200 Returns the list of roles */ ListRolesResponse;
export type RolesAdminControllerListRolesV1ApiArg = void;
export type RolesAdminControllerGetRoleV1ApiResponse =
  /** status 200 Role details */ GetRoleResponse;
export type RolesAdminControllerGetRoleV1ApiArg = {
  id: number;
};
export type RolesAdminControllerUpdateRoleV1ApiResponse =
  /** status 200 Returns updated role */ UpdateRoleResponse;
export type RolesAdminControllerUpdateRoleV1ApiArg = {
  id: number;
  updateRoleBody: UpdateRoleBody;
};
export type RolesAdminControllerRemoveRoleV1ApiResponse =
  /** status 200 Returns deleted role */ RemoveRoleResponse;
export type RolesAdminControllerRemoveRoleV1ApiArg = {
  id: number;
};
export type CreateRoleResponse = {
  /** Role ID */
  id: number;
  /** Role name */
  name: string;
  /** Optional description for the role */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type CreateRoleBody = {
  /** Role name */
  name: string;
  /** Optional description for the role */
  description?: null | string;
};
export type ListRolesResponse = {
  /** Role ID */
  id: number;
  /** Role name */
  name: string;
  /** Optional description for the role */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
}[];
export type GetRoleResponse = {
  /** Role ID */
  id: number;
  /** Role name */
  name: string;
  /** Optional description for the role */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type UpdateRoleResponse = {
  /** Role ID */
  id: number;
  /** Role name */
  name: string;
  /** Optional description for the role */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
export type UpdateRoleBody = {
  /** Optional description for the role */
  description?: null | string;
};
export type RemoveRoleResponse = {
  /** Role ID */
  id: number;
  /** Role name */
  name: string;
  /** Optional description for the role */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  metadata?: {
    resourceKind?: string;
    allowedActions?: string[];
  };
};
